if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('.product-media-modal__thumb');
          if (!thumb || !this.contains(thumb)) return;
          event.preventDefault();
          event.stopPropagation();
          this.openedBy = thumb;
          this.showActiveMedia();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.ensureThumbs();
        this.showActiveMedia();
      }

      ensureThumbs() {
        const content = this.querySelector('[role="document"]');
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!content || !dialog) return;

        let stage = this.querySelector('.product-media-modal__stage');
        if (!stage) {
          stage = document.createElement('div');
          stage.className = 'product-media-modal__stage';
          content.parentElement.insertBefore(stage, content);
          stage.appendChild(content);
        }

        let thumbs = this.querySelector('.product-media-modal__thumbs');
        if (!thumbs) {
          thumbs = document.createElement('div');
          thumbs.className = 'product-media-modal__thumbs';
          thumbs.setAttribute('role', 'tablist');
          stage.insertBefore(thumbs, content);
        }

        const medias = Array.from(content.querySelectorAll('[data-media-id]'));
        thumbs.dataset.count = String(medias.length);
        const wanted = medias.map((media) => media.getAttribute('data-media-id'));
        const existing = Array.from(thumbs.querySelectorAll('.product-media-modal__thumb')).map((thumb) =>
          thumb.getAttribute('data-media-id')
        );
        if (wanted.length === existing.length && wanted.every((id, index) => id === existing[index])) return;

        thumbs.replaceChildren();
        medias.forEach((media) => {
          const source = media.matches('img') ? media : media.querySelector('img');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-media-modal__thumb';
          button.setAttribute('data-media-id', media.getAttribute('data-media-id'));
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-current', 'false');
          if (source) {
            const image = document.createElement('img');
            image.src = source.currentSrc || source.src;
            image.alt = source.alt || '';
            button.appendChild(image);
          }
          thumbs.appendChild(button);
        });
      }

      showActiveMedia() {
        this.ensureThumbs();
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const container = this.querySelector('[role="document"]');
        if (!mediaId || !container) return;

        container.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });

        this.querySelectorAll('.product-media-modal__thumb').forEach((thumb) => {
          const selected = thumb.getAttribute('data-media-id') === mediaId;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-current', selected ? 'true' : 'false');
        });

        const activeMedia = container.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView({ block: 'center', inline: 'nearest' });
        container.scrollTop = 0;
        container.scrollLeft = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
